import { Path } from "react-hook-form";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { BaseFieldProps } from "../BaseField/BaseField.component";
import { FormFieldProps, isFormRequired } from "../formField.types";
import { NumericTextField } from "../NumericTextField/NumericTextfield.component";
import { BonusCardFieldValues } from "./bonusCardField.schema";

type BonusCardFieldProperties = {
    placeholder: string;
    eBonusCardNumber?: string | null;
};

export type BonusCardFieldProps<T extends BonusCardFieldValues> =
    FormFieldProps<
        Omit<
            BaseFieldProps<BonusCardFieldValues, "bonusCardNumber">,
            "name" | "required"
        > &
            BonusCardFieldProperties & {
                required: isFormRequired<
                    T,
                    Extract<Path<T>, "bonusCardNumber">
                >;
            },
        T
    >;

const BonusCardField = <T extends BonusCardFieldValues = never>({
    label,
    placeholder,
    required,
    eBonusCardNumber
}: BonusCardFieldProps<T>) => {
    const { t } = useGranite();

    if (eBonusCardNumber) {
        return (
            <div>
                <div>{t("general.form.bonusCard.label")}</div>
                <div>{eBonusCardNumber}</div>
            </div>
        );
    } else {
        return (
            <NumericTextField<BonusCardFieldValues>
                name={"bonusCardNumber"}
                label={label}
                placeholder={placeholder}
                required={required}
            />
        );
    }
};

export { BonusCardField };
